import { createStart } from '@tanstack/react-start';

export const startInstance = createStart(() => ({
  // Disable SSR by default - itinerary-preview uses ssr: true for meta tags
  defaultSsr: 'data-only',
}));
